import React from "react";

import styles from "./SaveCancelBtn.module.scss";

const SaveCancelBtn = ({
  onSave,
  onCancel,
  position = "flex-end",
  margin = 20,
}) => {
  return (
    <div
      className={styles.save_cancel}
      style={{
        justifyContent: position,
        marginBottom: `${margin}px`,
        marginTop: `${margin}px`,
      }}
    >
      <button className={styles.cancel} onClick={() => onCancel()}>
        CANCEL
      </button>
      <button className={styles.save} onClick={() => onSave()}>
        SAVE
      </button>
    </div>
  );
};

export default SaveCancelBtn;
